import { useQuery } from '@tanstack/react-query';
import { fetchProductAddOns } from '../services/productAddons';

export const productAddOnKeys = {
    list: (productId: string) => ['smr-admin', 'product-addons', productId] as const,
};

export function useProductAddOnsQuery(productId: string | undefined) {
    return useQuery({
        queryKey: productAddOnKeys.list(productId ?? ''),
        queryFn: () => fetchProductAddOns(productId!),
        enabled: !!productId,
    });
}
